import { createFileRoute, redirect } from "@tanstack/react-router";

// Index of a school scope: redirect to its lessons page (portal's `_protected.$school._index`).
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/lessons",
      params: {
        locale: params.locale,
        schoolyear: params.schoolyear,
        school: params.school,
      },
    });
  },
});
